export enum symbolAssetConfig {
    // JSON_S1 = "assets/symbol/Wild_single.json",
    // IMAGE_S1 = "assets/symbol/Wild_single.png",
    // ANIMATION_S1 = "assets/symbol/symbolanimation/WildX2.json",
    // IMAGE_S2 = "assets/symbol/Banana.png",
    // ANIMATION_S3 = "assets/symbol/symbolanimation/k.png",
    // JSON_S3 = "assets/symbol/symbolanimation/k.json",
    // IMAGE_S4 = "assets/symbol/pear.png",
    // IMAGE_S5 = "assets/symbol/spades.png",
    // IMAGE_S6 = "assets/symbol/watermellon.png",
    // JSON_BAR = "assets/symbol/Bar_0_to_30.json",
    // JSON_BELL = "assets/symbol/Bell_0_to_30.json",
    // JSON_JOKER = "assets/symbol/Joker_0_to_30.json",
    // JSON_KIWI = "assets/symbol/Kiwi_0_to_30.json",
    // JSON_LOGO = "assets/symbol/Logo_0_to_30.json",
    // JSON_ORANGE = "assets/symbol/Orange_0_to_30.json",
    // JSON_PLUMP = "assets/symbol/Plum_0_to_30.json",
    // JSON_STAR = "assets/symbol/Star_0_to_30.json",
    // JSON_STRAWBERRY = "assets/symbol/Strawberry_0_to_30.json",
    // JSON_WATERMELON = "assets/symbol/Watermelon_0_to_30.json",

}